import { useState } from "react";
import { Button, Alert, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { logOut, selectCurrentUser } from "../../features/auth/authSlice";
import { deleteAccount } from "../../features/profileSlice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function DeleteAccount() {
    const [showModal, setShowModal] = useState(false);
    const [deletionScheduled, setDeletionScheduled] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(selectCurrentUser);

    const handleDelete = async () => {
        try {
            const resultAction = await dispatch(deleteAccount());

            if (deleteAccount.fulfilled.match(resultAction)) {
                setDeletionScheduled(true);
                setShowModal(false);

                // Optional: Log the user out
                dispatch(logOut());
                navigate("/");
            } else {
                // Optional: Show error
                alert("Failed to schedule account deletion: " + (resultAction.payload || "Unknown error"));
            }
        } catch (err) {
            console.error("Delete account error:", err);
            alert("An unexpected error occurred.");
        }
    };

    return (
        <div>
            <h4>Delete Account</h4>
            {!deletionScheduled ? (
                <>
                    <p className="text-danger mt-3">
                        Deleting your account is permanent. Your data will be scheduled for deletion 90 days from today.
                    </p>
                    <Button variant="danger" onClick={() => setShowModal(true)}>
                        Schedule Account Deletion
                    </Button>

                    {/* Confirmation Modal */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Account Deletion</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete your account?
                            <br />
                            <strong>
                                Your data will be removed permanently after 90 days.
                            </strong>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDelete}>
                                Confirm Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            ) : (
                <Alert variant="success" className="mt-4">
                    Your account has been scheduled for deletion. All associated data will be removed after 90 days.
                </Alert>
            )}
        </div>
    );
}

export default DeleteAccount;
